module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isCompact) ? _c('v-tabs', {
    attrs: {
      "vertical": "",
      "dark": "",
      "show-arrows": "",
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('v-tab', {
      key: item.id
    }, [(index === 0) ? _c('v-icon', [_vm._v("home")]) : _c('span', [_vm._v(_vm._s(item.title))])], 1)
  }), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-tab-item', {
      key: item.id
    }, [(item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      }
    }, 'component', item.attrs, false), item.evnts || {})) : _vm._e()], 1)
  }), 1)], 2) : _c('v-expansion-panel', {
    staticClass: "elevation-0",
    attrs: {
      "focusable": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-expansion-panel-content', {
      key: item.id,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('div', {
            staticClass: "subheading"
          }, [_vm._v("\n          " + _vm._s(item.title))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (item.component && _vm.activeTab === index) ? _c(item.component, _vm._g(_vm._b({
      tag: "component",
      attrs: {
        "lazy": ""
      }
    }, 'component', item.attrs, false), item.evnts || {})) : _vm._e()], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bd3cca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FlexibleComponentContainer.vue
// module id = 1432
// module chunks = 9